<template>
  <nav class="navbar navbar-header navbar-expand-lg" v-bind:data-background-color="headerBackground">
    <div class="container-fluid">
      <!-- <div class="collapse" id="search-nav">
        <form class="navbar-left navbar-form nav-search mr-md-3" @submit.prevent="search()" id="global-search-form">
          <div class="input-group">
            <div class="input-group-prepend">
              <button type="submit" class="btn btn-search pr-1">
                <i v-if="!searching" class="fa fa-search search-icon"></i>
                <i v-if="searching" class="fa fa-spinner fa-spin search-icon"></i>
              </button>
            </div>
            <input v-model="term" type="search" :placeholder="`${$t('search')} ...`" class="form-control" />
          </div>
        </form>
      </div> -->
      <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
        <li class="nav-item" v-if="!user.verified && artists.length && user.rejected_reason">
          <button class="btn btn-outline btn-sm in-review desktop-version" v-if ="(user._id && !user.verified && artists.length && user.rejected_reason && user.rejected_on)" @click="openModalReviewRejected(user.rejected_on, user.rejected_reason)">
            <span v-if="!loading"><i class="fas fa-exclamation-triangle"></i>{{ $t('not_approved') }}</span>
            <span v-else><i class="fa fa-spinner fa-spin"></i>{{ $t('loading') }}</span>
          </button>
        </li>
        <!-- <li class="nav-item toggle-nav-search hidden-caret">
          <a
            class="nav-link"
            data-toggle="collapse"
            href="#search-nav"
            role="button"
            aria-expanded="false"
            aria-controls="search-nav"
          >
            <i class="fa fa-search"></i>
          </a>
        </li> -->
        <li class="nav-item dropdown hidden-caret submenu" v-if="currentStrikes.length">
          <a class="nav-link dropdown-toggle" href="#" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-exclamation-triangle text-warning mr-1"></i> <span class="strong">{{ $t('active_strikes') }}</span>
          </a>
          <ul class="dropdown-menu animated fadeIn alert-warning strikes-dropdown" aria-labelledby="messageDropdown">
            <li v-for="(strike, index) in currentStrikes" v-bind:key="index">
              <a :href="'/distributions/' + strike.distribution._id" class="dropdown-item">
              <span>
                <span class="text-danger mr-2">
                  <i class="fas fa-circle text-danger mr-2 text-small"></i>Strike {{ index + 1 }}:
                </span>
                <span class="strong">
                  {{ strike.distribution.title }}
                </span>
                &nbsp;-&nbsp;
                <span class="text-small font-italic">{{ $t(strike.type) || "Strike" }}</span>
                <p class="text-small mb-0">{{ moment.utc(strike.createdAt).format('LL') }}</p>
              </span>
              </a>
            </li>
          </ul>
        </li>
        <!-- <li class="nav-item">
          <router-link to="/statements" class="nav-link"><i class="fas fa-dollar-sign"></i></router-link>
        </li> -->
        <li class="nav-item dropdown hidden-caret submenu">
          <a class="nav-link  dropdown-toggle" href="#" id="notificationDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="getMessages()">
            <i class="far fa-bell"></i>
            <span v-if="messages.length" class="notification">{{ ((messages.length > 10) ? messages.length : '9+') }}</span>
          </a>
          <ul class="dropdown-menu dropdown-user notif-box animated fadeIn">
            <li>
              <div class="dropdown-title">
                {{ $t('notifications') }} ({{messages.length}})
                <span class="ml-1" v-if="loadingMessage"><i class="fa fa-spinner fa-spin text-muted"></i></span>
              </div>
            </li>
            <li>
              <div class="notif-center">
                  <div v-for="message in messages" v-bind:key="message._id" class="notif-group">
                    <a @click="goToMessage(message)">
                      <div class="notif-img">
                        <img
                          :src="message.author ? (message.author.profile_image_small || message.author.profile_image || defaultImage) : defaultImage"
                          alt="..."
                          class="avatar-img rounded-circle"
                          onerror="this.src = '/static/img/img-placeholder-dark.jpg'"
                        />
                      </div>
                      <div class="notif-content">
                        <span class="block" v-html="message.subject"></span>
                        <span class="time">{{ moment.utc(message.createdAt).fromNow() }}</span>
                      </div>
                    </a>
                    <button type="button" class="btn btn-icon btn-light notif-action" title="" @click="goToMessage(message)">
                      <i class="fas fa-external-link-square-alt"></i>
                    </button>
                  </div>
              </div>
            </li>
            <li v-if="!messages.length">
              <a class="see-all" href="javascript:void(0);">{{ $t('without_notifications') }}{{messages.length}}</a>
            </li>
            <li>
              <router-link to="/messages/all" class="see-all">
                {{ $t('see_all_messages') }}<i class="fa fa-angle-down"></i>
              </router-link>
            </li>
          </ul>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" target="_blank" href="http://help.indiefy.net/">
            <i class="far fa-question-circle"></i>
          </a>
        </li> -->
        <li class="nav-item dropdown hidden-caret submenu">
          <a class="nav-link dropdown-toggle" href="#" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-language"></i><span v-if="currentLanguage" class="ml-2 desktop-version">{{ currentLanguage }}</span>
          </a>
          <ul class="dropdown-menu animated fadeIn" aria-labelledby="messageDropdown">
            <li>
              <a :href="`${basePath}?lang=en`" class="dropdown-item">
                English
              </a>
            </li>
            <li>
              <a :href="`${basePath}?lang=es`" class="dropdown-item">
                Español
              </a>
            </li>
            <li>
              <a :href="`${basePath}?lang=pt`" class="dropdown-item">
                Portuguese
              </a>
            </li>
            <li>
              <a :href="`${basePath}?lang=tr`" class="dropdown-item">
                Turkish
              </a>
            </li>
            <li>
              <a :href="`${basePath}?lang=ru`" class="dropdown-item">
                Russian
              </a>
            </li>
            <li>
              <a :href="`${basePath}?lang=ca`" class="dropdown-item">
                Catal&aacute;n
              </a>
            </li>
          </ul>
        </li>
        <!-- <li class="nav-item ml-1" v-if="user && !user.subscription">
          <router-link class="nav-link" to="/upgrade?from=user_header">
            <i class="fa fa-star text-warning"></i>
          </router-link>
        </li> -->
        <li class="nav-item dropdown hidden-caret ml-2">
          <a class="dropdown-toggle profile-pic" data-toggle="dropdown" href="#" aria-expanded="false">
            <div class="avatar-sm">
              <img
                :src="user.profile_image || defaultImage"
                alt="..."
                class="avatar-img rounded-circle"
                onerror="this.src = '/static/img/img-placeholder-dark.jpg'"
              />
            </div>
          </a>
          <ul class="dropdown-menu dropdown-user animated fadeIn">
            <div class="dropdown-user-scroll scrollbar-outer">
              <li>
                <div class="user-box">
                  <div class="avatar-lg">
                    <img
                      :src="user.profile_image || defaultImage"
                      alt="image profile"
                      class="avatar-img rounded"
                      onerror="this.src = '/static/img/img-placeholder-dark.jpg'"
                    />
                  </div>
                  <div class="u-text">
                    <h4>{{ user.name }} {{ user.last_name || '' }}</h4>
                    <p class="text-muted">{{ user.email }}</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="dropdown-divider"></div>
                <router-link to="/account/profile" class="dropdown-item">{{ $t('my_profile') }}</router-link>
                <router-link to="/statements" class="dropdown-item">{{ $t('royalties') }}</router-link>
                <div class="dropdown-divider"></div>
                <router-link to="/account" class="dropdown-item">{{ $t('account_settings') }}</router-link>
                <div class="dropdown-divider"></div>
                <a v-if="user && user.role === 'admin'" href="https://indiefy.net/v1/api/admin/toggle-subscription" class="dropdown-item">
                  Toggle Subscription (Admin)
                </a>
                <div class="dropdown-divider"></div>
                <router-link to="/logout" class="dropdown-item">{{ $t('logout') }}</router-link>
              </li>
            </div>
          </ul>
        </li>
        <li class="nav-item" v-if="user && user.impersonate">
          <a class="nav-link ml-2" href="https://indiefy.net/v1/auth/back-to-admin">
            Admin
          </a>
        </li>
      </ul>
      <ul class="navbar-nav topbar-nav ml-md-auto align-items-center in-review-mobile mobile-version" v-if ="(user._id && !user.verified && artists.length && !user.rejected_reason)">
        <li>
          <button @click="openModalReview()">
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ $t('in_review_title') }}</span>
          </button>
        </li>
      </ul>
      <ul class="navbar-nav topbar-nav ml-md-auto align-items-center in-review-mobile mobile-version" v-if ="(user._id && !user.verified && artists.length && user.rejected_reason && user.rejected_on)">
        <li>
          <button @click="openModalReviewRejected(user.rejected_on, user.rejected_reason)">
            <span v-if="!loading"><i class="fas fa-exclamation-triangle"></i><span>{{ $t('not_approved') }}</span></span>
            <span v-else><i class="fa fa-spinner fa-spin"></i><span>{{ $t('loading') }}</span></span>
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Messages from '../services/messages'
import Artists from '../services/artists'
import User from '../services/user'
import Strike from '../services/strikes'

export default {
  name: 'NavigationBar',
  data: function () {
    return {
      isMobileApp: navigator.userAgent.indexOf('gonative') >= 0,
      headerBackground: 'purple2',
      currentLanguage: '',
      moment: moment,
      artists: [],
      searching: false,
      lang: 'en',
      term: '',
      basePath: '/',
      page: '',
      user: {},
      messages: [],
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      currentStrikes: [],
      loading: false,
      loadingMessage: false
    }
  },
  methods: {
    search: function () {
      if (!this.term || this.term.length < 3) {
        return this.$notify(
          { message: this.$t('search_term_short') },
          'warning',
          'fa-exclamation'
        )
      }

      this.searching = true
      this.$router.push(`/search?q=${this.term}`)
    },
    openModalReview: function () {
      let html = document.createElement('div')
      html.innerHTML = '<div class="pr-4 pl-4">' + this.$t('in_review_message') + '</div>'
      window.swal({
        title: this.$t('in_review_title'),
        content: html,
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          close: {
            text: this.$t('close'),
            visible: true,
            className: 'btn btn-default btn-border no-border'
          }
        }
      })
    },
    openModalReviewRejected: function (rejectOnDate, rejectedReason) {
      User.getNow().then(response => {
        let now = response.data.now_iso
        let html = document.createElement('div')
        let today = moment(moment(now).format('YYYY-MM-DD'))
        let rejectDay = moment(moment(rejectOnDate).add(1, 'w').format('YYYY-MM-DD'))
        let daysPending = rejectDay.diff(today, 'days')
        let urlReject = 'https://help.indiefy.net/hc/en-us/articles/360045769454-Why-was-my-application-rejected-'
        if (this.lang === 'es') {
          urlReject = 'https://help.indiefy.net/hc/es/articles/360045769454--Porqu%C3%A9-fue-rechazada-mi-solicitud-de-registro-'
        }
        html.innerHTML =
          '<div class="pr-4 pl-4 text-center">' +
            this.$t('description_non_verified') +
            '<br><br><br><b>' + this.$t(rejectedReason) + '</b> <br>' +
            '<a href="' + urlReject + '" target="_blank">' +
              '<i style="font-size: 12px;">' + this.$t('what_is_this') + '</i>' +
            '</a><br><br>' +
            ((daysPending > 0) ? this.$t(daysPending === 1 ? 'verif_again_day' : 'verif_again_days').replace('NUMBER', daysPending) : this.$t('verif_now')) +
          '</div>'

        let buttons = {
          close: {
            text: this.$t('close'),
            visible: true,
            className: 'btn btn-default btn-border no-border'
          }
        }
        if (moment(moment(now).format('YYYY-MM-DD')).isSameOrAfter(moment(moment(rejectOnDate).add(1, 'w').format('YYYY-MM-DD')))) {
          buttons.confirm = {
            text: this.$t('request_verification'),
            className: 'btn btn-primary'
          }
        }

        window.swal({
          title: this.$t('title_non_verified'),
          content: html,
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: buttons
        }).then(confirm => {
          if (confirm !== true) {
            return
          }
          this.loading = true
          User.requestVerification().then(response => {
            this.loading = false
            _.extend(this.$user, response.data)
            this.$eventBus.$emit('updateUser', this.$user)
            this.$notify({ message: this.$t('verification_sent') }, 'success', 'fa-check')
          })
        })
      })
    },
    getMessages: function () {
      this.loadingMessage = true
      let params = {
        page: 0,
        limit: 20,
        unread: 1
      }
      Messages.getAll(params).then(response => {
        this.messages = response.data.items
        this.loadingMessage = false
        this.$forceUpdate()
      })
    },
    goToMessage: function (message) {
      let location = `/messages/${message._id}`
      if (this.$route.meta.mode === 'detail') {
        window.location = location
      } else {
        this.$router.push({ path: location })
      }
    }
  },
  watch: {
    term: _.debounce(function (value) {
      if (value && value.length >= 3) {
        this.search()
      }
    }, 100),
    $route: function (from, to) {
      this.page = this.$route.name
      this.basePath = `${location.protocol}//${location.host}${location.pathname}`
    }
  },
  created: function () {
    this.user = this.$user
    this.basePath = `${location.protocol}//${location.host}${location.pathname}`

    this.headerBackground = 'purple2'

    if (this.user.subscription) {
      if (this.user.subscription.plan_name === 'indiefy_lite') {
        this.headerBackground = 'light-blue2'
      } else {
        this.headerBackground = 'dark2'
      }
    }

    Strike.getStrikesByUser(this.user._id).then((response) => {
      this.currentStrikes = response.data

      _.each(this.currentStrikes, (strike) => {
        if (strike.distribution.title.length >= 15) {
          strike.distribution.title = `${strike.distribution.title.substring(0, 14)}...`
        }
      })
    }).catch(() => {})

    this.$eventBus.$on('updateUser', user => {
      this.user = user
    })

    this.getMessages()

    this.$eventBus.$on('endSearch', () => {
      setTimeout(() => {
        this.searching = false
        this.$forceUpdate()
      }, 10)
    })

    Artists.getAll({ limit: 1 }).then(response => {
      this.artists = response.data
    })

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.lang === 'en') {
      this.currentLanguage = 'English'
    } else if (this.lang === 'es') {
      this.currentLanguage = 'Español'
    } else if (this.lang === 'pt') {
      this.currentLanguage = 'Portuguese'
    } else if (this.lang === 'tr') {
      this.currentLanguage = 'Turkish'
    } else if (this.lang === 'ru') {
      this.currentLanguage = 'Russian'
    } else {
      this.currentLanguage = ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .navbar-header[data-background-color='beta'] {
    background: #17BEBB !important;
  }
  .strikes-dropdown {
    background-color: white !important
  }

  .dropdown-title {
    border-bottom: 1px solid #f1f1f1;
    color: #444444;
    font-size: 14px;
    font-weight: 600;
    padding: 12px 15px;
    text-align: left;
  }

  .notif-box, .messages-notif-box {
    width: 280px;
    padding: 0 !important;
    .notif-center{
      max-height: 70VH;
      overflow: auto;
      overflow-x: hidden;
    }
    .notif-group{
      position: relative;
      &:hover {
        .notif-action{
          display: block;
        }
      }
      .notif-action{
        border-radius: 50%;
        right: 10px;
        position: absolute;
        top: 10px;
        border-color: #BDBDBD;
      }
      .notif-center a {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      .notif-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        background: #eee;
        flex: 0 0 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
      }
      .notif-img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
        display: block;
      }
      .see-all {
        border-top: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        color: #555;
        font-size: 13px;
        font-weight: 400;
        text-decoration: none;
        &:hover {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 20px;
          color: #555;
          font-size: 13px;
          font-weight: 400;
          text-decoration: none;
        }
        i {
          float: right;
        }
      }
    }
  }

  .notif-box {
    .notif-scroll {
      max-height: 256px;
    }
  }

  .messages-notif-box {
    .message-notif-scroll {
      max-height: 250px;
    }
    .notif-center a {
      border-bottom: 1px solid #f1f1f1;
      &:last-child {
        border-bottom: 0px;
      }
      .notif-content {
        padding: 7px 15px 7px 5px;
      }
    }
  }
  .in-review {
    background: transparent;
    border: 1px solid #fff;
    color: #fff;
    i {
      margin-right: 10px;
    }
  }
  .in-review-mobile {
    background: #e6eef6;
    height: 42px;
    color: black;
    text-align: center;
    li {
      button {
        background: #e4ecf5;
        color: #32373b;
        border: none;
        margin: 0 auto;
        line-height: 1.5;
        i {
          font-size: 14px;
        }
        span {
          font-size: 12px;
          margin-left: 10px;
          font-weight: 600;
        }
      }
    }
  }
  .desktop-version {
    display: block;
  }
  .mobile-version {
    display: none;
  }
  @media screen and (max-width: 991px) {
    .desktop-version {
      display: none;
    }
    .mobile-version {
      display: block;
    }
    .navbar-header {
      padding: 0px;
    }
    .navbar-header .navbar-nav {
      padding: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue